import * as schemas from "./schemas";
import { CLIENT_TOKEN } from "shadow-client";
import generator from "shadow-client/endpoints/generator";

// products
const productGenerator = generator.with(`/${CLIENT_TOKEN}/products`, schemas.product);
export const fetchProductList = productGenerator.fetchEntityList;
export const fetchProduct = productGenerator.fetchEntity;

// product_behaviors
const productBehaviorsGenerator = generator.with(`/${CLIENT_TOKEN}/product_behaviors`, schemas.productBehavior);
export const fetchProductBehaviorList = productBehaviorsGenerator.fetchEntityList;

// offers
const offerGenerator = generator.with(`/${CLIENT_TOKEN}/offers`, schemas.offer);
export const fetchOfferList = offerGenerator.fetchEntityList;



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/productApi/index.js